import { Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './InfoModal.module.less';
import { LangText } from 'utils/interfaces';
import { I18nt } from 'utils';
import ModalWithImage from 'components/ModalwithImage';
import I18n from 'i18n-js';
import cn from 'classnames';

interface Props {
	visible: boolean;
	title: LangText;
	body?: LangText;
	onOk?: React.MouseEventHandler<HTMLElement>;
	okText?: LangText;
	dynamicText?: { [key: string]: string };
	footer?: JSX.Element;
	icon?: JSX.Element;
	iconClassName?: string;
	className?: string;
}

export default function InfoModal({
	visible,
	title,
	body,
	onOk,
	okText,
	dynamicText,
	icon,
	footer,
	iconClassName,
	className,
}: Props) {
	return (
		<ModalWithImage
			centered
			footer={null}
			closable={false}
			visible={visible}
			className={cn(styles.infoModal, className)}
		>
			<div className={styles.modalWrapper}>
				{icon ?? <ExclamationCircleOutlined className={iconClassName} />}
				<div className={styles.modalContent}>
					<h4>{I18nt(title)}</h4>
					{body ? I18n.t(body, dynamicText) : null}
					{footer ?? (
						<footer className={styles.modalFooter}>
							<Button onClick={onOk} type='primary'>
								{I18nt(okText ?? 'de_acuerdo')}
							</Button>
						</footer>
					)}
				</div>
			</div>
		</ModalWithImage>
	);
}
